import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { color } from 'styled-system';
import themeGet from '@styled-system/theme-get';
import { Dialog } from '@radix-ui/themes';

import { SignInModal } from '../../../shared/SignIn/SignInModal.jsx';
import { CreateAccountModal } from '../../../shared/SignIn/CreateAccountModal.jsx';
import defaultAttrs from '../../../lib/utils/defaultAttrs';

export default function GuestButton({
  guestUserResetPath,
  shouldConvertGuest,
  hideSignIn,
}) {
  const { t } = useTranslation('header');

  return (
    <Wrapper>
      {shouldConvertGuest === 'true' && (
        <Dialog.Root>
          <Dialog.Trigger>
            <Button
              variant="outlinedBlue"
              id="createAccountButton"
              color="primary.100"
            >
              {t('guestButtons.createAccount')}
            </Button>
          </Dialog.Trigger>
          <CreateAccountModal />
        </Dialog.Root>
      )}

      {hideSignIn !== 'true' && (
        <Dialog.Root>
          <Dialog.Trigger>
            <Button id="signInButton" color="black.80">
              {t('guestButtons.signIn')}
            </Button>
          </Dialog.Trigger>
          <SignInModal />
        </Dialog.Root>
      )}

      <StartOverButton
        id="guestUserConversion"
        data-method="patch"
        href={guestUserResetPath}
      >
        {t('guestButtons.startOver')}
      </StartOverButton>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  margin-left: auto;
  flex-direction: row-reverse;
  display: none;
  ${themeGet('mediaQueries.forMediumUp')} {
    flex-direction: row;
    display: flex;
  }
`;

const Button = styled.button.attrs(
  defaultAttrs({
    as: 'a',
  }),
)`
  border: 1px solid #007eff;
  box-sizing: border-box;
  border-radius: 8px;
  background: transparent;
  margin: 0;
  ${color};
  padding: 0;
  font-size: 12px;
  font-weight: 600;
  border: none;

  &:hover {
    background: #007eff;
    color: white;
  }

  &:focus {
    background: transparent;
    color: #007eff;
  }

  ${themeGet('mediaQueries.forMediumUp')} {
    padding: 11px 16px;
    font-size: 14px;
    border: 1px solid ${themeGet('colors.primary.100')};
    color: ${themeGet('colors.primary.100')};
  }
  &:nth-child(2) {
    margin: 0 16px;
  }
`;

const StartOverButton = styled(Button)`
  display: none;
  ${themeGet('mediaQueries.forMediumUp')} {
    display: inline;
  }
`;
